import { render, staticRenderFns } from "./Grid23.vue?vue&type=template&id=6579e8de&scoped=true&"
import script from "./Grid23.vue?vue&type=script&lang=ts&"
export * from "./Grid23.vue?vue&type=script&lang=ts&"
import style0 from "./Grid23.vue?vue&type=style&index=0&id=6579e8de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6579e8de",
  null
  
)

export default component.exports